import { IRapportInfo } from '../../../../../Types/RapportInfoType';
// import { rapportInfos } from '../RapportInfo';

const GARapportMeny: IRapportInfo[] = [];

export default GARapportMeny;
